/**
 * EmailInput
 *
 * Preconfigured `Input` wrapper for e-mail address entry.
 * Sets `type="email"`, `inputMode="email"`, and defaults `leftContent` to an envelope icon.
 * Callers may override `leftContent` (e.g. with a different envelope variant).
 */
import * as React from 'react';
import { Input, type InputProps } from './Input';
import { Icon } from '../icons/Icon';

export type EmailInputProps = Omit<InputProps, 'type'>;

export const EmailInput = React.forwardRef<HTMLInputElement, EmailInputProps>(
  ({ leftContent, ...props }, ref) => (
    <Input
      {...props}
      type='email'
      inputMode='email'
      leftContent={leftContent ?? <Icon name='envelope' />}
      ref={ref}
    />
  )
);

EmailInput.displayName = 'EmailInput';
